import { render, staticRenderFns } from "./KitchenDisplay.vue?vue&type=template&id=2e5985d3&scoped=true&"
import script from "./KitchenDisplay.vue?vue&type=script&setup=true&lang=js&"
export * from "./KitchenDisplay.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./KitchenDisplay.vue?vue&type=style&index=0&id=2e5985d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5985d3",
  null
  
)

export default component.exports